import { defineComponent as g, ref as v, computed as p, createElementBlock as t, openBlock as o, normalizeClass as s, createCommentVNode as a, createElementVNode as S, createVNode as n, renderSlot as c, withCtx as d, toDisplayString as h } from "vue";
import { _ as b } from "./Icon.ce.vue_vue_type_script_setup_true_lang-CdOC0ycX.js";
import { _ as y } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import I from "./Spinner.ce.js";
const C = ["type", "disable"], k = {
  key: 0,
  class: "spinner-overlay"
}, B = {
  key: 0,
  class: "arbo-btn__label"
}, D = /* @__PURE__ */ g({
  __name: "Button.ce",
  props: {
    label: {
      type: String,
      default: "My Button"
    },
    type: {
      type: String,
      default: "primary"
    },
    isSubmitBtn: {
      type: Boolean,
      default: !1
    },
    disable: {
      type: Boolean,
      default: !1
    },
    prefixIcon: {
      type: String,
      default: ""
    },
    prefixTooltip: {
      type: String,
      default: ""
    },
    suffixIcon: {
      type: String,
      default: ""
    },
    suffixTooltip: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "normal"
    },
    isDanger: {
      type: Boolean,
      default: !1,
      required: !1
    },
    tooltipTheme: {
      type: String,
      default: "arbo",
      required: !1
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    spinnerSize: {
      type: Number,
      default: 20
    },
    spinnerThickness: {
      type: Number,
      default: 3
    }
  },
  setup(l) {
    const r = v(!1), e = l, m = p(() => "#D7D7D7"), _ = p(() => "#FFFFFF"), f = p(() => [
      e.type.toLowerCase(),
      e.size.toLowerCase(),
      {
        disable: e.disable,
        hovering: r.value,
        danger: e.isDanger,
        "is-loading": e.isLoading && e.type !== "tertiary"
      }
    ]);
    return (u, i) => (o(), t("button", {
      class: s(["arbo-btn", [...f.value, { "has-prefix-icon": e.prefixIcon }, { "has-suffix-icon": e.suffixIcon }, { "no-padding": !e.label }]]),
      type: e.isSubmitBtn ? "submit" : "button",
      disable: e.disable,
      onMouseenter: i[0] || (i[0] = (x) => r.value = !0),
      onMouseleave: i[1] || (i[1] = (x) => r.value = !1)
    }, [
      e.isLoading && e.type !== "tertiary" ? (o(), t("div", k, [
        n(I, {
          size: l.spinnerSize,
          thickness: l.spinnerThickness,
          color: m.value,
          secondaryColor: _.value
        }, null, 8, ["size", "thickness", "color", "secondaryColor"])
      ])) : a("", !0),
      S("div", {
        class: s(["button-content", { "invisible-content": e.isLoading && e.type !== "tertiary" }])
      }, [
        c(u.$slots, "prefix", {
          prefixIcon: e.prefixIcon
        }, () => [
          n(y, {
            class: "arbo-btn__tooltip",
            content: e.prefixTooltip,
            delay: [300, 0],
            theme: e.tooltipTheme
          }, {
            default: d(() => [
              e.prefixIcon ? (o(), t("div", {
                key: 0,
                class: s(["arbo-btn__prefix arbo__icon-btn", [...f.value]])
              }, [
                n(b, {
                  class: "arbo-label__prefix--icon",
                  name: e.prefixIcon
                }, null, 8, ["name"])
              ], 2)) : a("", !0)
            ]),
            _: 1
          }, 8, ["content", "theme"])
        ]),
        c(u.$slots, "default", {}, () => [
          e.label ? (o(), t("div", B, h(e.label), 1)) : a("", !0)
        ]),
        c(u.$slots, "suffix", {
          suffixIcon: e.suffixIcon
        }, () => [
          n(y, {
            class: "arbo-btn__tooltip",
            content: e.suffixTooltip,
            delay: [300, 0]
          }, {
            default: d(() => [
              e.suffixIcon ? (o(), t("div", {
                key: 0,
                class: s(["arbo-btn__suffix arbo__icon-btn", [...f.value]])
              }, [
                n(b, {
                  class: "arbo-label__prefix--icon",
                  name: e.suffixIcon
                }, null, 8, ["name"])
              ], 2)) : a("", !0)
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ], 2)
    ], 42, C));
  }
});
export {
  D as _
};
